var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "chartBar", staticClass: "chart-bar" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }